import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('订单状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "data-permission": "transport_order_old_list_status",
      "id": "transport_order_old_list_status",
      "data-sign": "transport_order_list_status",
      "animated": false
    },
    on: {
      "change": _vm.handleOrderStatusChange
    },
    model: {
      value: _vm.searchData.order_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_status", $$v);
      },
      expression: "searchData.order_status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [_vm._v(" " + _vm._s(item.text + "(" + item.total + ")") + " ")])]);
  }), 1)], 1), _c('div', [_c('my-enter-search', {
    attrs: {
      "data-sign": "transport_order_list_form"
    },
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "transport_order_old_list_code_type",
      "id": "transport_order_old_list_code_type"
    },
    model: {
      value: _vm.searchData.order_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_type", $$v);
      },
      expression: "searchData.order_type"
    }
  }, _vm._l(_vm.orderTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "data-permission": "transport_order_old_list_code_value",
      "id": "transport_order_old_list_code_value",
      "data-sign": "transport_order_list_dblclick",
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u9884\u62A5\u4ED3\u5E93"),
      "data-permission": "transport_order_old_list_warehouse_code",
      "id": "transport_order_old_list_warehouse_code",
      "show-tip": "",
      "allow-clear": "",
      "show-search": "",
      "placeholder": _vm.t('预报仓库')
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(_vm._s(item.warehouse_code) + "[" + _vm._s(item.warehouse_name) + "]")]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u7269\u6D41\u4EA7\u54C1"),
      "data-permission": "transport_order_old_list_sm_code",
      "id": "transport_order_old_list_sm_code",
      "show-tip": "",
      "allow-clear": "",
      "show-search": "",
      "placeholder": _vm.t('物流产品')
    },
    model: {
      value: _vm.searchData.product_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_code", $$v);
      },
      expression: "searchData.product_code"
    }
  }, _vm._l(_vm.logisticsList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.product_code
      }
    }, [_vm._v(_vm._s(item.product_code) + "[" + _vm._s(item.product_cnname) + "]")]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u6807\u7B7E\u7C7B\u578B"),
      "data-permission": "transport_order_old_list_label_type",
      "id": "transport_order_old_list_label_type",
      "show-tip": "",
      "allow-clear": "",
      "show-search": "",
      "placeholder": _vm.t('标签类型')
    },
    model: {
      value: _vm.searchData.label_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "label_type", $$v);
      },
      expression: "searchData.label_type"
    }
  }, _vm._l(_vm.labelTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u56FD\u5BB6/\u5730\u533A"),
      "data-permission": "transport_order_old_list_country_code",
      "id": "transport_order_old_list_country_code",
      "show-tip": "",
      "allow-clear": "",
      "dropdown-match-select-width": false,
      "show-search": "",
      "placeholder": _vm.t('国家/地区')
    },
    model: {
      value: _vm.searchData.country_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "country_code", $$v);
      },
      expression: "searchData.country_code"
    }
  }, [_c('a-select-opt-group', {
    attrs: {
      "label": _vm.t('常用国家/地区')
    }
  }, _vm._l(_vm.countryList.filter(function (item) {
    return _vm.$config.commonlyCountryList.includes(item.code);
  }), function (item, index) {
    return _c('a-select-option', {
      key: index + 'commonlyCountryList',
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.code) + "[" + _vm._s(item.name) + "]")]);
  }), 1), _c('a-select-opt-group', {
    attrs: {
      "label": _vm.t('其他国家/地区')
    }
  }, _vm._l(_vm.countryList.filter(function (item) {
    return !_vm.$config.commonlyCountryList.includes(item.code);
  }), function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.code) + "[" + _vm._s(item.name) + "]")]);
  }), 1)], 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u8BA2\u5355\u7C7B\u578B"),
      "data-permission": "transport_order_old_list_order_type",
      "id": "transport_order_old_list_order_type",
      "show-tip": "",
      "allow-clear": "",
      "show-search": "",
      "placeholder": _vm.t('订单类型')
    },
    model: {
      value: _vm.searchData.onevote,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "onevote", $$v);
      },
      expression: "searchData.onevote"
    }
  }, _vm._l(_vm.onevoteEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u9884\u4E0A\u7F51"),
      "data-permission": "transport_order_old_list_pre_on_net",
      "id": "transport_order_old_list_pre_on_net",
      "show-tip": "",
      "allow-clear": "",
      "show-search": "",
      "placeholder": _vm.t('是否预上网')
    },
    model: {
      value: _vm.searchData.is_advance,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_advance", $$v);
      },
      expression: "searchData.is_advance"
    }
  }, _vm._l(_vm.yesNoStatus, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u521B\u5EFA\u65F6\u95F4"),
      "allow-clear": false,
      "data-permission": "transport_order_old_list_date_type",
      "id": "transport_order_old_list_date_type",
      "placeholder": _vm.t('创建时间')
    },
    model: {
      value: _vm.searchData.date_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "date_type", $$v);
      },
      expression: "searchData.date_type"
    }
  }, _vm._l(_vm.dateTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('my-range-picker', {
    attrs: {
      "data-permission": "transport_order_old_list_range_picker",
      "id": "transport_order_old_list_range_picker",
      "limit-range-day": this.$enum.common.TimePeriodEnum.THREE_MONTH,
      "allow-clear": true,
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.timeValue,
      callback: function ($$v) {
        _vm.timeValue = $$v;
      },
      expression: "timeValue"
    }
  })], 1)], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom",
      "margin-top": "10px"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingStatus,
      "ghost": "",
      "data-permission": "transport_order_old_list_search",
      "id": "transport_order_old_list_search",
      "data-sign": "transport_order_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "transport_order_old_list_reset",
      "id": "transport_order_old_list_reset",
      "data-sign": "transport_order_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(this.selectedList.length) + " "), _c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "transport_order_old_list_export_all",
      "id": "transport_order_old_list_export_all",
      "data-sign": "transport_order_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "transport_order_old_list_export_selected",
      "id": "transport_order_old_list_export_selected",
      "data-sign": "transport_order_list_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "data-permission": "transport_order_old_list_export",
      "id": "transport_order_old_list_export",
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _vm.searchData.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.DRAFT || _vm.searchData.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.FORECAST ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'old_transport_order_cancel',
      expression: "'old_transport_order_cancel'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "transport_order_old_list_cancel",
      "id": "transport_order_old_list_cancel",
      "data-sign": "transport_order_list_cancel_bulk",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleCancelBulk
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]) : _vm._e(), _vm.searchData.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.OUT ? _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "transport_order_old_list_print_shipping_certificate",
      "id": "transport_order_old_list_print_shipping_certificate",
      "data-sign": "transport_order_list_print_certificate",
      "fbu-analyse-name": $t("\u6253\u5370\u53D1\u8D27\u8BC1\u660E")
    },
    on: {
      "click": _vm.handlePrintCertificateBulk
    }
  }, [_vm._v(_vm._s(_vm.t('打印发货证明')))]) : _vm._e(), _vm.searchData.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.FORECAST ? _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "transport_order_old_list_print_label",
      "id": "transport_order_old_list_print_label",
      "data-sign": "transport_order_list_print_label",
      "fbu-analyse-name": $t("\u6253\u5370\u6807\u7B7E")
    },
    on: {
      "click": _vm.handlePrintLabelBulk
    }
  }, [_vm._v(_vm._s(_vm.t('打印标签')))]) : _vm._e(), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'transport_order_settings',
      expression: "'transport_order_settings'"
    }],
    staticClass: "fr",
    attrs: {
      "type": "primary",
      "data-permission": "transport_order_old_list_print_setting",
      "id": "transport_order_old_list_print_setting",
      "data-sign": "transport_order_list_print_setting",
      "fbu-analyse-name": $t("\u6253\u5370\u8BBE\u7F6E")
    },
    on: {
      "click": _vm.handlePrintSetting
    }
  }, [_vm._v(_vm._s(_vm.t('打印设置')))])], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext order-draft-table-box",
    attrs: {
      "bordered": "",
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "columns": _vm.columns,
      "data-source": _vm.listData,
      "name": "historyTransportOrderList",
      "data-sign": "transport_order_list_table",
      "row-key": "shipper_hawbcode",
      "orderListEsPoint": _vm.orderListEsPoint,
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "shipper_hawbcode",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "min-width": "210px"
          }
        }, [_c('div', {
          staticClass: "order-code"
        }, [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.shipper_hawbcode,
            expression: "record.shipper_hawbcode"
          }],
          attrs: {
            "to": {
              name: 'HistoryTransportOrderDetailPage',
              query: {
                code: record.shipper_hawbcode
              }
            },
            "data-sign": "transport_order_list_item_order_code"
          }
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record.shipper_hawbcode)))])], 1)]);
      }
    }, {
      key: "country_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.address ? _c('div', [record.address.country_code ? _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.address.country_code)))]) : _vm._e(), record.address.country_code_text ? _c('span', [_vm._v("[" + _vm._s(record.address.country_code_text) + "]")]) : _vm._e()]) : _vm._e()]);
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.warehouse_code ? _c('span', [_vm._v(_vm._s(record.warehouse_code))]) : _vm._e(), record.warehouse_name ? _c('span', [_vm._v("[" + _vm._s(record.warehouse_name) + "]")]) : _vm._e()]);
      }
    }, {
      key: "consignee_name",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.shipper_consignee ? _c('div', [_c('span', {
          staticClass: "mr-10"
        }, [_vm._v(_vm._s(record.shipper_consignee.consignee_name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(record.shipper_consignee.consignee_lastname))])]) : _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }, {
      key: "order_create_code_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.order_create_code_text)) + " "), record.is_print_sign ? _c('p', {
          staticClass: "mt-5"
        }, [_vm._v(_vm._s(_vm.t('已打印')))]) : _vm._e()]);
      }
    }, {
      key: "order_status_str",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.cancel_status === _vm.$enum.transportOrder.CancelStatusEnum.REFUNDED ? _c('div', [_vm._v(" " + _vm._s(_vm.t('已取消')) + " ")]) : _vm._e(), _c('div', [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.order_status_str)) + " ")])]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "170px"
          }
        }, [_c('p', [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.t('common', '：')) + _vm._s(_vm._f("filterEmpty")(record.create_date)))]), _c('p', [_vm._v(_vm._s(_vm.t('入库')) + _vm._s(_vm.t('common', '：')) + _vm._s(_vm._f("filterEmpty")(record.checkin_date)))]), _c('p', [_vm._v(_vm._s(_vm.t('出库')) + _vm._s(_vm.t('common', '：')) + _vm._s(_vm._f("filterEmpty")(record.checkout_date)))])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.FORECAST ? [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'transport_order_cancel',
            expression: "'transport_order_cancel'"
          }],
          attrs: {
            "data-sign": "transport_order_list_item_cancel",
            "fbu-analyse-name": $t("\u53D6\u6D88")
          },
          on: {
            "click": function ($event) {
              return _vm.handleCancel(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('取消')))])] : _vm._e(), [record.order_status === _vm.$enum.historyTransportOrder.OrderStatusEnum.FORECAST ? _c('a', {
          staticClass: "ml-10",
          attrs: {
            "data-sign": "transport_order_batch_list_item_print",
            "fbu-analyse-name": $t("\u6253\u5370\u6807\u7B7E")
          },
          on: {
            "click": function ($event) {
              return _vm.handlePrintLabel(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('打印标签')))]) : _vm._e()]], 2);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "value": _vm.searchData.page_index,
      "name": "historyTransportOrderList",
      "total": _vm.total,
      "isFixed": "",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "max-number": _vm.$config.orderCodeBatchSearchMax
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };